















































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import BankAccountDTO, { AchForm } from "@/dto/BankAccountDTO";
import FileMetaDTO from "@/dto/files/FileMetaDTO";
import SingleFileHolder from "@/components/util/SingleFileHolder.vue";

const AppModule = namespace("App");

@Component({
	components: {
		SingleFileHolder
	}
})
export default class AchFormManager extends Vue {
	@Prop({ required: true })
	bankAccount!: BankAccountDTO;

	@AppModule.State
	private isMobile!: boolean;

	private showManualFormUpload = false;

	get achForms(): AchForm[] {
		return this.bankAccount.achForms || [];
	}

	get signableForm(): AchForm | null {
		return this.achForms.find(form => form.formType === "SIGNABLE") || null;
	}

	get manualForms(): AchForm[] {
		return this.achForms.filter(form => form.formType === "MANUAL");
	}

	get hasAnyForms(): boolean {
		return this.achForms.length > 0;
	}

	private downloadForm(file: FileMetaDTO): void {
		this.$emit('download-form', file.id);
	}

	private toggleManualFormUpload(): void {
		this.showManualFormUpload = !this.showManualFormUpload;
	}

	private handleManualFormUpload(file: FileMetaDTO | null): void {
		if (file) {
			this.$emit('add-manual-form', file);
			this.showManualFormUpload = false;
		}
	}

	private deleteManualForm(form: AchForm): void {
		this.$emit('delete-manual-form', form);
	}

	private createSignableForm(): void {
		this.$emit('create-signable-form');
	}

	private deleteSignableForm(): void {
		this.$emit('delete-signable-form');
	}

	private formatDate(date: Date): string {
		if (!date) return 'Unknown';
		
		const dateObj = new Date(date);
		return dateObj.toLocaleDateString('en-US', {
			year: 'numeric',
			month: 'short',
			day: 'numeric',
			hour: '2-digit',
			minute: '2-digit'
		});
	}
}
